import { Auth } from "aws-amplify";

export const register = ({ email, password, username }) => {
  return Auth.signUp({
    username,
    password,
    attributes: { email },
  });
};
